<template>
  <div class="tabZujian">
    <swiper>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first" :key="'first'" >
          <child1 v-if="isAll" v-bind:arg = {temp}></child1>
        </el-tab-pane>

        <el-tab-pane label="古筝" name="second" :key="'second'">
          <child1 v-if="isGuzheng" v-bind:arg = {temp}></child1>
        </el-tab-pane>

        <el-tab-pane label="非洲鼓" name="three" :key="'three'">
          <child1 v-if="isFeizhougu"  v-bind:arg = {temp}></child1>
        </el-tab-pane>
        <el-tab-pane label="爵士鼓" name="four" :key="'four'">
          <child1 v-if="isJueshigu" v-bind:arg = {temp}></child1>
        </el-tab-pane>
        <el-tab-pane label="口才" name="five" :key="'five'">
          <child1 v-if="isTalk"  v-bind:arg = {temp}></child1>
        </el-tab-pane>
        
      </el-tabs>
    </swiper>
  </div>
</template>

<script>
import tabZujianChild1 from "@/tabComponents/tabZujianChild1";
import tabZujianChild2 from "@/tabComponents/tabZujianChild2";
import Swiper from "./index/swiper.vue";
export default {
  name: "tabZujian",
  components: {
    child1: tabZujianChild1,
    child2: tabZujianChild2,
  },
  data() {
    return {
      //向后台传递参数
      temp: "all",
      dataObj:'dataObj',
      //默认第一个选项卡
      activeName: "first",
      isAll: true,
      isGuzheng: false,
      isFeizhougu: false,
      isJueshigu: false,
      isTalk: false,
      whether:false
    };
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleClick(tab) {
      if (tab.name == "first") {
        //更改temp值
        this.temp = "all";
        console.log(this.temp);
        this.isAll = true;
        this.isGuzheng = false;
        this.isFeizhougu = false;
        this.isJueshigu = false;
        this.isTalk = false;
      } else if (tab.name == "second") {
        //更改temp值
        this.temp = "guZheng";
        console.log(this.temp);
        this.isAll = false;
        this.isGuzheng = true;
        this.isFeizhougu = false;
        this.isJueshigu = false;
        this.isTalk = false;
      } else if (tab.name == "three") {
        //更改temp值
        this.temp = "feizhougu";
        console.log(this.temp);
        this.isAll = false;
        this.isGuzheng = false;
        this.isFeizhougu = true;
        this.isJueshigu = false;
        this.isTalk = false;
      } else if (tab.name == "four") {
        //更改temp值
        this.temp = "jueshigu";
        console.log(this.temp);
        this.isAll = false;
        this.isGuzheng = false;
        this.isFeizhougu = false;
        this.isJueshigu = true;
        this.isTalk = false;
      } else if (tab.name == "five") {
        //更改temp值
        this.temp = "talk";
        console.log(this.temp);
        this.isAll = false;
        this.isGuzheng = false;
        this.isFeizhougu = false;
        this.isJueshigu = false;
        this.isTalk = true;
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log(scrollTop)
      if (scrollTop > 175) {
        this.whether = true;
      } else {
        this.whether = false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.tabZujian {
  height: auto;
  width: auto;
  top: 15px;
}
.tabZujian .el-tabs__item {
  font-size: 29px;
}
</style>